import { render, staticRenderFns } from "./ListColaborator.vue?vue&type=template&id=614dce94"
import script from "./ListColaborator.vue?vue&type=script&lang=js"
export * from "./ListColaborator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports